import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const CustomTT = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    fontSize: '1rem', // Ajusta el tamaño de la fuente según tus necesidades
  },
}));

const CustomTooltip = ({ title, placement, children }) => {
  return (
    <CustomTT title={title} placement={placement}>
      {children}
    </CustomTT>
  );
};

export default CustomTooltip;
